export const AUTH_TOKEN_KEY = 'auth_token';
export const TOKEN_CHECK_INTERVAL = 15000;
export const EXPIRED_TOKEN_ERROR = 'TokenExpired';

export const LEGACY_WIDGET_AUTH_METHOD = 'SSO';

export enum AuthMethod {
  SBA = 'SBA',
  WIDGET = 'WIDGET',
  OAUTH = 'OAUTH',
}

export const LSL_CLIENT_ID = 'qantas_hotels_self_service';
export const LSL_AUTH_DATA = 'lsl_auth_data';
export const LSL_USER_ID_COOKIE = 'lsl_user_id';
export const LSL_SESSION_COOKIE = 'qh_sess';

export const OAUTH_STATE = 'oauth_state';
export const OAUTH_REDIRECT_ROUTE = 'oauth_redirect_route';

export const QLFF_WL_SESS = 'qlff_wl_sess';

export const QF_VALUE = 'QF_VALUE';
